export default "__VITE_ASSET__c6979010__"